import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';

/**
 * "Sort by: X ×" pill, or "Sort: ⇄" when nothing is picked: the sort control
 * of the project tabs' toolbars (RFIs, Submittals, Punchlists...), which each
 * inline the same markup. Same markup and styles, as a component.
 */
@Component({
  selector: 'app-project-details-page-sort-dropdown',
  templateUrl: './sort-dropdown.component.html',
  styleUrls: ['./sort-dropdown.component.scss'],
  standalone: false,
})
export class SortDropdownComponent {
  @ViewChild('sortSelect') sortSelect: MatSelect;
  @Input() options: readonly string[] = [];
  @Input() value: string = null;
  @Input() panelClass = 'rfi-sort-panel';
  @Output() valueChange = new EventEmitter<string | null>();

  onSelect(value: string): void {
    this.value = value;
    this.valueChange.emit(value);
  }

  clear(event: Event): void {
    event?.stopPropagation();
    this.value = null;
    this.valueChange.emit(null);
  }

  open(event?: Event): void {
    // The select panel renders as an inline popover inside this wrapper, so the
    // click that closes it bubbles back here: only react to the pill itself.
    const target = event?.target as HTMLElement | null;
    if (target?.closest('.cdk-overlay-popover, .cdk-overlay-backdrop')) return;
    this.sortSelect?.open?.();
  }
}
